module.exports = __webpack_public_path__ + "img/P150T_weapon_50.15ff10b0.png";